import { UseGuardStepHook } from "../useGuardStep";
import { useFlowState } from "@/hooks/useFlowState";
import { useCurrentWorkspace, useWorkspacesInitializing } from "@/store";
import { useLocation } from "react-router-dom";

export const useGuardNoWorkspace: UseGuardStepHook = () => {
    const currentWorkspace = useCurrentWorkspace();
    const workspacesInitializing = useWorkspacesInitializing();
    const { step, computeUrlPath } = useFlowState();
    const location = useLocation();

    if (workspacesInitializing) {
        return { loading: true, passThrough: true, errors: [], redirect: null };
    }

    const intendedPath = currentWorkspace?.url ? `/${currentWorkspace.url}` : "/";

    const shouldRedirect = !location.pathname.startsWith(intendedPath);

    return {
        loading: false,
        step,
        passThrough: !shouldRedirect,
        errors: [],
        redirect: shouldRedirect ? computeUrlPath({ workspaceUrl: currentWorkspace?.url }) : null
    };
};
